import { useNavigate } from "react-router-dom";

import { ArrowRightExtraThinIcon } from "components/icons";
import TruncateText from "components/TruncateText";

import useBreadcrumb from "./useBreadcrumb";
import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

const Breadcrumb = () => {
  const { breadcrumbItems } = useBreadcrumb();
  const navigate = useNavigate();

  const { t } = useTranslationContext();

  const handleClickBreadcrumbItem = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="w-full h-[3rem]">
      <ul className={"h-[3rem] flex items-center text-gray-900 gap-x-1"}>
        {breadcrumbItems.map((item, index) => (
          <li
            key={index}
            className={cn(
              "flex items-center",
              item.link &&
                index !== breadcrumbItems.length - 1 &&
                "cursor-pointer",
              index === breadcrumbItems.length - 1 && "font-bold text-night"
            )}
            onClick={
              index !== breadcrumbItems.length - 1
                ? () => handleClickBreadcrumbItem(item.link)
                : undefined
            }
          >
            <TruncateText
              id={`breadcrumb-${index}`}
              className="flex"
              text={item?.label ? t(item.label) : "..."}
              tooltipWidth={item?.label?.length > 70 ? "18.75rem" : "auto"}
            />

            {index < breadcrumbItems.length - 1 && (
              <span>
                <ArrowRightExtraThinIcon
                  color="#808080"
                  width={8}
                  height={16}
                  className="ml-2 mr-1"
                />
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Breadcrumb;
